module.exports = __webpack_public_path__ + "static/media/4.14d37641.png";